import React from 'react';
import { Furniture } from '../../../lib/modelBuilder/entities/Furniture';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../../App/types';
import {
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from '../selectors/furniture';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FiCornerUpLeft } from 'react-icons/all';
import { displayFurniture } from '../actions/furniture';
import showFurnitureImg from '../../../assets/images/ribbons/cabinetRibbon/showFurniture.svg';
import Img from '../../../components/Img';
import { makeSelectMenuOpen } from '../../Ribbon/ShelvesRibbon/selectors';

// import styled from 'styled-components';

interface StateProps {
  selectedCabinetId: string | null;
  furniture: Furniture | null;
  selvesSelectionMenuOpen: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  selectedCabinetId: makeSelectSelectedIdCabinet(),
  furniture: makeSelectFurniture(),
  selvesSelectionMenuOpen: makeSelectMenuOpen(),
});

const ShowFurnitureButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedCabinetId, furniture, selvesSelectionMenuOpen } = useSelector(
    stateSelector,
  );

  if (selvesSelectionMenuOpen) {
    return null;
  }

  if (
    furniture !== null &&
    furniture.quantity >= 2 &&
    selectedCabinetId !== null
  ) {
    return (
      <button
        onClick={() => {
          dispatch(displayFurniture());
        }}
        className="border p-1 flex items-center "
      >
        <FiCornerUpLeft className="h-6 w-6 text-main mr-1 " />
        <Img src={showFurnitureImg} alt={'show'} className="h-14 w-12" />
        {/*{t('Back')}*/}
      </button>
    );
  } else {
  }
  return null;
};

export default ShowFurnitureButton;
